import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { AuthService } from '../services/auth.service';
import * as moment from 'moment';
import { environment } from '../../environments/environment';

@Injectable()
export class AuditOpeningStockCylsService {
  constructor(private http: HttpClient, private authService: AuthService) { }

  public getResults(page: Page, distribution_Id: number, quick_Search: string): Promise<PagedData<any>> {
    const pagedData = new PagedData<any>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Inspected_At'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'desc'; }

      let params = '&distribution_Id=' + distribution_Id;
      params += '&quick_Search=' + quick_Search;
                            
      this.http.get<ServerData>(environment.apiUrl + 'distribution/GetTableAuditOpening?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.total;
        page.totalPages = page.totalElements / page.size;
        console.log("Data Retrieved")
        console.log(data);
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }
        
        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }

  public getHeadlineDetails(distribution_Id: number): Promise<any> {
    const headlineDetails = new Array();

    return new Promise((resolve, reject) => {

      let params = '?distribution_Id=' + distribution_Id
      console.log("Headline 1")
      this.http.get<ServerData>(environment.apiUrl + 'distribution/GetHeadlineDetails' + params).subscribe(data => {

        console.log("Data Retrieved")
        console.log(data);

        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          headlineDetails.push(jsonObj);
        }

        resolve(headlineDetails);

      }, error => {
        reject();
      });
    });
  }

/*  public getAll(page: Page, company_Id: number, location_Id: number, tabletUser_Id: string, start_Date: string, end_Date: string, serial_Num: string): Promise<any> {
    const pagedData = new PagedData<any>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Inspected_At'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'desc'; }

      let params = '&company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;
      params += '&tabletUser_Id=' + tabletUser_Id;
      params += '&start_Date=' + moment(start_Date).format('YYYY-MM-DD');
      params += '&end_Date=' + moment(end_Date).format('YYYY-MM-DD');
      params += '&serial_Num=' + serial_Num;
      var is_Client = this.authService.currentUser.value.userType == 0;
      params += '&is_Client=' + is_Client;

      this.http.get<any>('/api/inspection/getall?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        resolve(data.data);

      }, error => {
        reject();
      });
    });
  }*/

/*  public getImages(inspectionId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>('api/inspection/getimages?inspectionId=' + inspectionId.toString()).subscribe(data => {
        let blob = this.converBase64toBlob(data, 'application/zip');
        resolve(blob);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }*/

  converBase64toBlob(content, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;
    let byteCharacters = window.atob(content); //method which converts base64 to binary
    let byteArrays = [
    ];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
      type: contentType
    }); //statement which creates the blob
    return blob;
  }

/*  public getApprovalDetails(page: Page, locationinspection_Id:string): Promise<any> {
    const pagedData = new PagedData<any>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Inspected_At'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'desc'; }

      let params = '&locationinspection_Id=' + locationinspection_Id;

      this.http.get<any>('/api/inspection/getUnapproved?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.total;
        page.totalPages = page.totalElements / page.size;

        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }*/

  public getExcel(customer_Type_Id: number, company_Id: number, location_Id: number, pda_User_ID: number,
    start_Date: string, end_Date: string, is_Client: boolean): Promise<any> {

    return new Promise((resolve, reject) => {

      let params = '?customer_Type_Id=' + customer_Type_Id;
      params += '&company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;
      params += '&start_Date=' + moment(start_Date).format('YYYY-MM-DD');
      params += '&end_Date=' + moment(end_Date).format('YYYY-MM-DD');

      var is_Client = this.authService.currentUser.value.userType == 0;
      params += '&is_Client=' + is_Client;

      this.http.get<any>(environment.apiUrl + 'distribution/GetExcel' + params).subscribe(data => {
        let blob = this.converBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public getAllInspections(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>('/api/inspection/getallInspections').subscribe(data => {
        resolve(data);
      }, error => {
        reject();
      });
    });
  }

  public getAllInspectionsEngineers(): Promise<any> {

    return new Promise((resolve, reject) => {
      this.http.get<any>('/api/inspection/getAllInspectionsEngineers').subscribe(data => {
        
        resolve(data);
        
      }, error => {
        reject();
      });
    });
  }



}
